
<div v-if="!renderData.loading">
  <component :is="renderData.currentUpload"></component>
</div>
